import { Injectable } from '@angular/core';
import { LoadingState } from '../../../common/enums/loading-state.enum';
import { IDashboard } from '../types/idashboard';

@Injectable({
    providedIn: 'root'
})
export class DashboardCacheService {
    public dashboards = new Map<number, IDashboard>();
    public locationsBeingFetched = new Set<number>();

    public getCachedDashboard(locationId: number) {
        return this.dashboards.get(locationId);
    }

    public getDevicesForArea(locationId: number, areaId: number) {
        return this.getCachedDashboard(locationId).areaDevices.get(areaId || -1);
    }

    public getAlertsForArea(locationId: number, areaId: number) {
        return this.getCachedDashboard(locationId).areaAlerts.get(areaId || -1);
    }

    public getAlertsForDevice(locationId: number, deviceId: number) {
        return this.getCachedDashboard(locationId).deviceAlerts.get(deviceId);
    }
}
